import React from 'react';

const SubjectsAndDiscipline = () => {
    const subjects = [
        'GCSE Maths', 'GCSE English Language', 'GCSE English Literature', 'GCSE Biology', 'GCSE Chemistry',
        'GCSE Physics', 'GCSE History', 'GCSE Geography', 'GCSE French', 'GCSE Spanish', 'A-Level Maths',
        'A-Level Further Maths', 'A-Level Biology', 'A-Level Chemistry', 'A-Level Physics', 'A-Level Economics',
        '11+ Verbal Reasoning', '11+ Non-Verbal Reasoning', 'SATs Preparation', 'Tabla',
        'University Interviews', 'Bharatanatyam', 'Carnatic Music', 'Hindustani Classical', 'Classical Guitar',  'Kuchipudi',
        'Veena', 'Watercolour Painting', 'UCAS Personal Statements',   'Tamil', 'Telugu', 'Hindi', 'Gujarati', 'Punjabi',
        'Sanskrit', 'Kannada', 'Bengali', 'Marathi'
    ];

    return (
        <div className="w-full px-6 sm:px-12 md:px-16 lg:pl-20 lg:pr-12 relative pt-0 pb-8 min-h-[500px]">
            {/* Main heading */}
            <h1 className="text-left text-4xl md:text-5xl font-black text-[#5c3e21] mb-5 tracking-tight">
                Subjects & Disciplines
            </h1>

            {/* Subheading */}
            <p className="text-left text-xl md:text-2xl font-bold text-[#8c5021] mb-6">
                Whatever your student needs, we have an Acharya for it.
            </p>

            {/* Subject list – responsive flex-wrap with styled badges */}
            <div className="flex flex-wrap justify-start gap-3">
                {subjects.map((subject, index) => (
                    <span
                        key={index}
                        className="bg-[#fdf8ed] border border-[#d18b4e] rounded-full px-4 py-2 text-sm md:text-base font-medium text-gray-800 hover:bg-[#d18b4e] hover:text-white transition duration-200"
                    >
                        {subject}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default SubjectsAndDiscipline;